import { generateColors } from "@mantine/colors-generator";
import { createTheme, Input, Pill, Title } from "@mantine/core";

import classes from "./mantineTheme.module.scss";
import { applicationContainerSizes } from "./layoutSizes";

/**
 * Defines application palettes, breakpoints, typography and component defaults at module load.
 * Postconditions: The theme shares container sizes with the CSS resolver and retains disabled-input
 * and pill classes. Importing constructs theme data; it does not mount a provider or persist settings.
 */
const mantineTheme = createTheme({
    fontFamily: "Roboto, sans-serif",
    colors: {
        primary: generateColors("#00447A"),
        secondary: generateColors("#fea002"),
        information: generateColors("#29b6f6"),
        warning: generateColors("#ffa726"),
        success: generateColors("#66bb6a"),
        error: generateColors("#f44336"),

        "ngt-form-description": generateColors("#2e2e2e"),
        "ngt-form-information": generateColors("#228be6"),
        "ngt-form-warning": generateColors("#fab005"),
        "ngt-form-low": generateColors("#ca5252"),
        "ngt-form-medium": generateColors("#da5252"),
        "ngt-form-high": generateColors("#ea5252"),
        "ngt-form-critical": generateColors("#fa5252")
    },
    primaryColor: "primary",
    primaryShade: 9,
    breakpoints: {
        xs: "36em",
        sm: "48em",
        md: "62em",
        lg: "75em",
        xl: "88em"
    },
    components: {
        Container: {
            vars: () => ({
                root: {
                    "--container-size-xs": applicationContainerSizes.xs,
                    "--container-size-sm": applicationContainerSizes.sm,
                    "--container-size-md": applicationContainerSizes.md,
                    "--container-size-lg": applicationContainerSizes.lg,
                    "--container-size-xl": applicationContainerSizes.xl
                }
            })
        },
        Input: Input.extend({
            classNames: {
                input: classes.disabledInput
            }
        }),
        Pill: Pill.extend({
            classNames: {
                root: classes.disabledPill
            }
        }),
        Title: Title.extend({
            defaultProps: {
                c: "primary"
            }
        })
    },
    fontWeights: {
        medium: "400"
    },
    headings: {
        fontWeight: "400"
    }
});

export default mantineTheme;
